module.exports = __webpack_public_path__ + "img/view.a9bfa471.svg";